var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonPlain',_vm._g(_vm._b({staticClass:"ae-button",class:[_vm.fill, _vm.size, { plain: _vm.plain }]},'ButtonPlain',_vm.$attrs,false),_vm.$listeners),[(_vm.spinner)?_c('AeSpinner'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }